"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REGEXP_EMAIL = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

exports.default = REGEXP_EMAIL;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/constants/regexpEmail.js
 ** module id = 1234
 ** module chunks = 0
 **/